<script setup>
import { onMounted, ref, computed } from 'vue'
import { Icon } from '@components'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import Calendar from './Calendar.vue'
import DateLoader from './DateLoader.vue'
import Main from '../layout/Main.vue'
import { isSm } from '../../../../utilities/mediaQuery'

onMounted(async () => {
    // $appointments.matchAppointmentPreRequirement()
    await $appointments.fetchAvailableDates(null, null, 60)
})

const updateAppointment = (value) => {
    $appointments.setAppointment('booking_date', value)
    $appointments.fetchAvailableSlots()
}

const showBackButton = computed(() => {
    return $settings.isWidget || isSm
})
</script>

<style lang="scss" scoped></style>

<template>
    <Main>
        <template #content>
            <div class="flex items-center gap-1 mb-5">  
                <Icon name="chevronLeft" class="cursor-pointer" :class="{'hidden': !showBackButton}" size="24px" @click="$appointments.prevStep()" />
                <div class="date-page-title" :style="$customizer.titleStyle">{{ $settings.customizer.date.title || '' }}</div>
            </div>

            <!-- empty date loader -->
            <DateLoader v-if="!$appointments.isAvailableDatesLoaded" />

            <!-- date calendar -->
            <Calendar v-if="$appointments.isAvailableDatesLoaded" v-model="$appointments.appointment.booking_date" @change="(value) => updateAppointment(value)" />

        </template>
    </Main>
</template>